import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const Cie = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "CIE",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
      className={clsx(className, classes)}
    >
      <path
        fill="#fff"
        d="m7.769 3.472.752-.265L17.7.044a.69.69 0 0 1 .685.133c.189.169.333.381.42.619.266.686.531 1.35.797 2.057a4.9 4.9 0 0 1 .265 1.969c-.022.287-.066.575-.066.862a3.3 3.3 0 0 0 0 .664c.022.288.044.575.088.863.06.57.274 1.113.62 1.57.619.797 1.216 1.615 1.835 2.433q.471.631.841 1.328c.095.169.148.358.155.553a.9.9 0 0 1-.089.486c-.149.28-.352.529-.597.73q-.414.367-.907.62a2.1 2.1 0 0 0-.663.508.75.75 0 0 0-.11.797l.198.508a.84.84 0 0 1-.11.907 2 2 0 0 1-.177.244.7.7 0 0 0-.089.553l.066.265a.69.69 0 0 1-.177.575c-.132.133-.243.288-.353.42a1.35 1.35 0 0 0-.332.974q.03.316.133.619c.092.353.13.72.11 1.084a1.68 1.68 0 0 1-.907 1.46 1.53 1.53 0 0 1-.885.133l-1.15-.2c-1.438-.243-2.831-.597-4.247-.906l-1.482-.31h-.044c2.477-1.593 4.092-3.805 4.69-6.68a9.93 9.93 0 0 0-1.571-7.986c-1.66-2.455-4.004-3.893-6.88-4.424M3.699 12.72c-1.062 0-1.77-.288-2.146-.863S1 10.331 1 9.004s.2-2.278.575-2.831c.376-.553 1.084-.841 2.124-.841.685 0 1.368.082 2.035.243v.952A11 11 0 0 0 3.83 6.35c-.619 0-1.04.199-1.26.575-.222.376-.354 1.061-.354 2.101s.11 1.725.331 2.101c.222.377.642.553 1.261.553a11.3 11.3 0 0 0 1.925-.154v.973a9.7 9.7 0 0 1-2.035.221M6.64 6.48V5.285h1.15V6.48zm0 6.127V7.364h1.15v5.243z"
      ></path>
      <path
        fill="#fff"
        d="M12.701 11.657h.287v.84a9.8 9.8 0 0 1-2.123.244c-.774 0-1.327-.2-1.659-.641-.332-.443-.509-1.107-.509-2.036 0-1.858.752-2.787 2.279-2.787s2.19.797 2.19 2.411l-.067.797H9.87c-.02.348.082.692.288.973.177.2.509.287 1.018.287zM12.059 9.6c0-.53-.066-.885-.243-1.084s-.442-.31-.818-.31a1.1 1.1 0 0 0-.863.31c-.177.221-.265.575-.265 1.084zM5.468 21.167V14H6.64v7.167zM10.335 21.167h-2.5V14h2.5c1.083 0 1.858.265 2.256.84.398.576.597 1.438.597 2.633a7.7 7.7 0 0 1-.11 1.526 3.7 3.7 0 0 1-.42 1.15c-.4.686-1.173 1.018-2.323 1.018m1.658-3.694c0-.885-.11-1.504-.331-1.88s-.664-.575-1.328-.575H9.008v5.131h1.328c.685 0 1.15-.265 1.37-.774a2.5 2.5 0 0 0 .222-.818q.073-.54.066-1.084"
      ></path>
    </svg>
  );
};
